import { Component, Injector, OnInit, computed, forwardRef, input, model, signal, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { DxTagBoxComponent, DxTagBoxModule } from 'devextreme-angular';
import { ValueChangedEvent } from 'devextreme/ui/tag_box';
import { DECORATOR_HOST, DecoratorHost } from 'src/app/controls/directives/decorator-host';

@Component({
  selector: 'app-multiselectbox',
  templateUrl: './multiselectbox.component.html',
  styleUrls: ['./multiselectbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiselectboxComponent),
      multi: true
    },
    { 
      provide: DECORATOR_HOST, 
      useExisting: forwardRef(() => MultiselectboxComponent) 
    }
  ],
  host: {
    class: 'link-component'
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DxTagBoxModule]
})
export class MultiselectboxComponent implements OnInit, ControlValueAccessor, DecoratorHost {
  private dx = viewChild.required<DxTagBoxComponent>('dx');
  private ngControl: NgControl = null;

  value = model<unknown[]>(null);
  dataSource = input.required<unknown[]>();
  valueExpr = input<string>('id');
  displayExpr = input<string>(null);

  computedValue = computed(() => this.value() || []);

  private readonly inputId = signal<string | null>(null);
  protected readonly inputAttr = computed<Record<string, string>>(() => this.inputId() ? { id: this.inputId() } : {});

  constructor(
    private injector: Injector
  ) { }

  ngOnInit(): void {
    try {
      this.ngControl = this.injector.get(NgControl);
    }
    catch {
      // No NgControl
    }
  }
  get control(): AbstractControl {
    return this.ngControl?.control;
  }

  get isValid(): boolean {
    return !this.control || (this.control.invalid !== true || (this.control.pristine && this.control.untouched));
  }

  onValueChanged(e: ValueChangedEvent): void {
    if (e.value !== this.computedValue()) {
      this.onChanged(e.value);
      this.value.set(e.value as unknown[]);
    }
  }


  /*
   * ControlValueAccessor interface methods
   */

  writeValue(obj: unknown[]): void {
    this.value.set(obj);
  }

  onChanged: (value: unknown) => void = () => { };
  registerOnChange(fn: (value: unknown) => void): void {
    this.onChanged = fn;
  }

  onTouched: () => void = () => { };
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.dx().disabled = isDisabled;
  }


  /*
   * DecoratorHost interface methods
   */

  setInputId(inputId: string | null): void {
    this.inputId.set(inputId);
  }

  getInputId(): string | null {
    return this.inputId();
  }
}
